import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
//import { MohTranslateService } from 'moh-package';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  //title = 'Gazezet';
  //constructor(private translate: MohTranslateService) {
  constructor() {
    
  }

  ngOnInit() {
 
    //let defaultLanguage: string = 'he';
   // this.translate.setDefaultLang(defaultLanguage);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/app.component.ts